import { History } from 'history'
import * as React from 'react'
import { match } from 'react-router'
import { RelativeLink } from '../relativeLink'
import Saving from '../saving/index'
import './flagHeader.scss'

interface RouteParameters {
  engagementId: string
}

interface Properties {
  match: match<RouteParameters>
  history: History
}

function FlagHeader({ match: { url, params } }: Properties) {
  return (
    <div className='engagement-header'>
      <div className='flag-header flex-wrap'>
        <div>
          <RelativeLink to={`engagements/${params.engagementId}`}>
            Flags
          </RelativeLink>
          <Saving showLastSaved={true} />
        </div>
      </div>
    </div>
  )
}

export default FlagHeader
